import { format } from 'date-fns';

export default function formatDate(
  date: string | Date,
  formater?: string,
): string {
  return format(new Date(date), formater || 'MM/dd/yyyy');
}
